import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=ba505c56&scoped=true"
import script from "./LoginIndex.vue?vue&type=script&lang=js"
export * from "./LoginIndex.vue?vue&type=script&lang=js"
import style0 from "./LoginIndex.vue?vue&type=style&index=0&id=ba505c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba505c56",
  null
  
)

export default component.exports